module.exports = __webpack_public_path__ + "img/01b63d600641a711013e399127ea44.jpg@1280w_1l_2o_100sh.4ecd4f35.jpg";